<script setup>
import { useAttrs, computed, ref, onMounted, onUnmounted } from 'vue';
import logoUrl from 'assets/images/leadster-logo-v2.webp';
import logoWhiteUrl from 'assets/images/leadster-logo-v2-white.webp';

const props = defineProps({
  type: {
    type: String,
    default: null,
    validator: value => ['light', 'dark'].includes(value),
  },
});

const attrs = useAttrs();

const isDark = ref(document.body.classList.contains('dark'));

let observer = null;

onMounted(() => {
  observer = new MutationObserver(() => {
    isDark.value = document.body.classList.contains('dark');
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});

const currentLogo = computed(() => {
  if (props.type === 'light') {
    return logoUrl;
  }
  if (props.type === 'dark') {
    return logoWhiteUrl;
  }
  return isDark.value ? logoWhiteUrl : logoUrl;
});
</script>

<template>
  <img v-bind="attrs" :src="currentLogo" alt="Leadster" />
</template>
